import buildAccessibilityMessage from './buildAccessibilityMessage';

export default function buildAccessibilityMessageFromErrors({
  getErrorCount,
  setState,
  clearFirst = false,
  initialDelay = 200,
  buildDelay = 50,
}) {
  setTimeout(() => {
    const errorCount = getErrorCount();
    if (errorCount > 0) {
      const buildMessage = () => {
        setTimeout(() => {
          const accessibilityMessage = buildAccessibilityMessage(errorCount);
          setState((prevState) => ({
            errorCount,
            accessibilityMessage,
            accessibilityMessageKey: prevState.accessibilityMessageKey + 1,
          }));
        }, buildDelay);
      };

      if (clearFirst) {
        setState({ accessibilityMessage: '' }, () => {
          buildMessage();
        });
      } else {
        buildMessage();
      }
    }
  }, initialDelay);
}
